/**
 * How many squads a party makes, the way the publisher divides it
 * (`MissionPublisher.squadPlan`): a squad is at most `squadSize` seats and at
 * most the role table's own length, since its one leader is the table's first
 * row and a second leader starts another squad. A party under six stays one
 * squad unless `squadSize` itself is smaller.
 */
export interface SquadRole {
  role: string;
  count?: number;
}

export function squadCount(players: number, squadSize: number, roles: SquadRole[]): number {
  const size = Math.max(2, Math.min(12, Math.round(squadSize) || 8));
  const party = Math.max(1, players);
  let leader = false;
  let others = 0;
  for (const r of roles) {
    const seats = Math.max(1, Math.min(12, r.count ?? 1));
    if (!r.role.includes('leader')) {
      others += seats;
    } else if (!leader) {
      leader = true;
    }
  }
  if (roles.length === 0) {
    // No table: the publisher's own default squad, which is led and as long as `squadSize`.
    return Math.max(1, Math.ceil(party / size));
  }
  if (!leader || others === 0) {
    return Math.max(1, Math.ceil(party / size));
  }
  const cap = party < 6 ? size : Math.min(size, 1 + others);
  return Math.max(1, Math.ceil(party / cap));
}
